import React, { useEffect, useState } from 'react';
import { Sidebar } from './components/Sidebar';
import { VideoGrid } from './components/VideoGrid';
import { PreviewManager } from './components/PreviewManager';
import { PlatformSwitcher, Platform } from './components/PlatformSwitcher';
import { SpotifyPreview } from './components/SpotifyPreview';
import { ApplePodcastsPreview } from './components/ApplePodcastsPreview';
export function App() {
  const [customVideos, setCustomVideos] = useState([]);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [currentPlatform, setCurrentPlatform] = useState<Platform>('youtube');
  // Function to shuffle array (Fisher-Yates algorithm)
  const shuffleArray = array => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  };
  // Randomize videos when they change
  const [randomizedVideos, setRandomizedVideos] = useState([]);
  useEffect(() => {
    setRandomizedVideos(shuffleArray(customVideos));
  }, [customVideos]);
  const addCustomVideo = video => {
    setCustomVideos([...customVideos, {
      ...video,
      id: Date.now().toString()
    }]);
  };
  const addMultipleCustomVideos = videos => {
    console.log('App received videos to add:', videos.length);
    // Make sure each video has the required properties
    const processedVideos = videos.map(video => ({
      ...video,
      id: video.id || Date.now().toString(),
      videoId: video.videoId === undefined ? null : video.videoId,
      isCustom: true
    }));
    setCustomVideos(prevVideos => [...prevVideos, ...processedVideos]);
    console.log('Updated customVideos count:', customVideos.length + processedVideos.length);
  };
  const removeCustomVideo = id => {
    setCustomVideos(customVideos.filter(video => video.id !== id));
  };
  const updateCustomVideo = (id, updates) => {
    setCustomVideos(customVideos.map(video => video.id === id ? {
      ...video,
      ...updates
    } : video));
  };
  // Render the appropriate platform preview
  const renderPlatformPreview = () => {
    switch (currentPlatform) {
      case 'spotify':
        return <SpotifyPreview videos={randomizedVideos} onRemoveVideo={removeCustomVideo} onUpdateVideo={updateCustomVideo} data-id="element-0" />;
      case 'apple-podcasts':
        return <ApplePodcastsPreview videos={randomizedVideos} onRemoveVideo={removeCustomVideo} onUpdateVideo={updateCustomVideo} data-id="element-1" />;
      case 'youtube':
      default:
        return <VideoGrid customVideos={randomizedVideos} onRemoveVideo={removeCustomVideo} onUpdateVideo={updateCustomVideo} data-id="element-2" />;
    }
  };
  return <div className="flex flex-col min-h-screen bg-[#0f0f0f] text-white" data-id="element-3">
      {/* Preview controls section - completely outside both sidebar and platform content */}
      <div className="w-full bg-[#0f0f0f] p-4 md:p-6 border-b border-[#272727]" data-id="element-4">
        <PreviewManager onAddVideo={addCustomVideo} onAddMultipleVideos={addMultipleCustomVideos} data-id="element-5" />
        <PlatformSwitcher currentPlatform={currentPlatform} onChange={setCurrentPlatform} data-id="element-6" />
      </div>
      <div className="flex flex-1" data-id="element-7">
        <Sidebar isOpen={sidebarOpen} data-id="element-8" />
        <div className="flex-1 flex flex-col overflow-hidden" data-id="element-9">
          {/* Platform-specific content area */}
          <main className="flex-1 overflow-auto" data-id="element-10">
            {renderPlatformPreview()}
          </main>
        </div>
      </div>
    </div>;
}